"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _bd = require("@/api/bd");
var defaultFormData = {
  login_id: '',
  password: '',
  name: '',
  phone: '',
  country_code: '',
  pay_type: '',
  pay_account: '',
  status: 1,
  remark: ''
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    statusFilter: function statusFilter(status) {
      return Number(status) === 1 ? '启用' : '停用';
    }
  },
  data: function data() {
    var _this = this;
    var validatePassword = function validatePassword(rule, value, callback) {
      if (_this.dialogType === 'new' && !value) {
        callback(new Error('请输入登录密码'));
      } else {
        callback();
      }
    };
    return {
      listLoading: false,
      list: [],
      total: 0,
      times: [],
      statusList: [{
        label: '启用',
        value: 1
      }, {
        label: '停用',
        value: 0
      }],
      listQuery: {
        page: 1,
        size: 20,
        bdId: '',
        loginId: '',
        name: '',
        phone: '',
        countryCode: '',
        status: '',
        startTime: '',
        endTime: ''
      },
      dialogVisible: false,
      dialogType: 'new',
      credentialInputReadonly: true,
      formData: (0, _objectSpread2.default)({}, defaultFormData),
      rules: {
        login_id: {
          required: true,
          message: '请输入登录账号',
          trigger: 'blur'
        },
        password: {
          validator: validatePassword,
          trigger: 'blur'
        },
        name: {
          required: true,
          message: '请输入BD姓名',
          trigger: 'blur'
        },
        phone: {
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        },
        status: {
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }
      }
    };
  },
  watch: {
    times: function times(val) {
      this.listQuery.startTime = val ? val[0] : '';
      this.listQuery.endTime = val ? val[1] : '';
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$bdAccountList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _bd.bdAccountList)(this.listQuery);
            case 1:
              _yield$bdAccountList = _context.v;
              code = _yield$bdAccountList.code;
              data = _yield$bdAccountList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    enableCredentialInput: function enableCredentialInput() {
      this.credentialInputReadonly = false;
    },
    handleEdit: function handleEdit(row) {
      var _this2 = this;
      this.dialogType = row ? 'edit' : 'new';
      this.formData = row ? (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, defaultFormData), row), {}, {
        password: ''
      }) : (0, _objectSpread2.default)({}, defaultFormData);
      this.credentialInputReadonly = true;
      this.dialogVisible = true;
      this.$nextTick(function () {
        return _this2.$refs.editForm.clearValidate();
      });
    },
    confirmEdit: function confirmEdit() {
      var _this3 = this;
      this.$refs.editForm.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(valid) {
          var _yield$editBdAccount, code;
          return (0, _regenerator2.default)().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2, false);
              case 1:
                _context2.n = 2;
                return (0, _bd.editBdAccount)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.formData), {}, {
                  type: _this3.dialogType
                }));
              case 2:
                _yield$editBdAccount = _context2.v;
                code = _yield$editBdAccount.code;
                if (code === 0) {
                  _this3.$message({
                    message: _this3.dialogType === 'edit' ? _this3.$t('form.editSuccess') : _this3.$t('form.addSuccess'),
                    type: 'success'
                  });
                  _this3.dialogVisible = false;
                  _this3.getList();
                }
              case 3:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleStatus: function handleStatus(row) {
      var _this4 = this;
      var status = row.status === 1 ? 0 : 1;
      var action = status === 1 ? '启用' : '停用';
      this.$confirm("\u786E\u5B9A\u8981".concat(action, "\u8BE5BD\u8D26\u53F7\u5417\uFF1F"), this.$t('tips.tips'), {
        confirmButtonText: this.$t('form.confirm'),
        cancelButtonText: this.$t('form.cancel'),
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var _yield$updateBdAccoun, code;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _bd.updateBdAccountStatus)({
                bd_id: row.bd_id,
                status: status
              });
            case 1:
              _yield$updateBdAccoun = _context3.v;
              code = _yield$updateBdAccoun.code;
              if (code === 0) {
                _this4.$message({
                  message: _this4.$t('form.editSuccess'),
                  type: 'success'
                });
                _this4.getList();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      })));
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      this.$confirm('确定要停用并保留该BD历史数据吗？', this.$t('tips.tips'), {
        confirmButtonText: this.$t('form.confirm'),
        cancelButtonText: this.$t('form.cancel'),
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var _yield$deleteBdAccoun, code;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return (0, _bd.deleteBdAccount)({
                bd_id: row.bd_id
              });
            case 1:
              _yield$deleteBdAccoun = _context4.v;
              code = _yield$deleteBdAccoun.code;
              if (code === 0) {
                _this5.$message({
                  message: '删除成功',
                  type: 'success'
                });
                _this5.getList();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      })));
    }
  }
};